import client from './client';

export const gameAPI = {
  getSortingHatQuestions: () => client.get('/game/sorting-hat-questions'),
  submitSortingHat: (answers) => client.post('/game/test/sorting-hat', { answers }),
  getProfile: () => client.get('/game/profile'),
  updateProfile: (data) => {
    const isFormData = data instanceof FormData;
    return client.put('/game/profile', data, isFormData ? {
      headers: { 'Content-Type': 'multipart/form-data' }
    } : undefined);
  },
  viewInvitation: (code, phone, birthDate, { firstName, lastName } = {}) =>
    client.post('/game/invitation/view', { code, phone, birthDate, firstName, lastName }),
  requestInvitationViewOTP: (code, phone) => client.post('/game/invitation/otp/request', { code, phone }),
  verifyInvitationViewOTP: (code, phone, otp) => client.post('/game/invitation/otp/verify', { code, phone, otp }),
  peekInvitation: (code) => client.post('/game/invitation/peek', { code }),
  trackInvitationView: (code) => client.post('/game/invitation/track-view', { code }),

  // Secret Message Page
  secretCheck: (code) => client.post('/game/invitation/secret/check', { code }),
  secretOTPRequest: (code, phone) => client.post('/game/invitation/secret/otp/request', { code, phone }),
  secretOTPVerify: (code, phone, otp) => client.post('/game/invitation/secret/otp/verify', { code, phone, otp }),
  secretSetBirthDate: (code, phone, birthDate) => client.post('/game/invitation/secret/birthdate', { code, phone, birthDate }),
  secretView: (code, phone) => client.post('/game/invitation/secret/view', { code, phone }),

  // لیست وسایل سال اول — برگه‌ی جداگانه، عمومی
  getSchoolSupplies: (year = 1) => client.get('/game/school-supplies', { params: { year } }),

  // Kings Cross — «به‌زودی» placeholder بعد از عبور موفق از سکو
  getKingsCrossStatus: () => client.get('/game/kings-cross'),

  // Platform 9¾ crossing (probability-based, requires JWT)
  testPlatform934: () => client.post('/game/test/platform-9-3-4'),

  // تسک‌های جایزه (گالیون) — عضویت تلگرام (خودکار)، پست/استوری اینستاگرام، توییت (تایید ادمین/استاد)
  getRewardTasks: () => client.get('/year-game/tasks'),
  submitRewardTask: (taskId, note) => client.post(`/year-game/tasks/${taskId}/submit`, { note }),
  getTelegramLink: () => client.get('/year-game/telegram/link'),
  getHouseTelegramInvite: () => client.get('/game/telegram/house-invite'),
  getSchoolTelegramInvite: () => client.get('/game/telegram/school-invite'),

  completeBirthdayGreeting: () => client.post('/game/profile/birthday-greeted'),
};

export const getSortingHatQuestions = () => gameAPI.getSortingHatQuestions();
export const submitSortingHat = (answers) => gameAPI.submitSortingHat(answers);
export const getProfile = () => gameAPI.getProfile();
export const updateProfile = (data) => gameAPI.updateProfile(data);
export const viewInvitation = (code, phone, birthDate, nameOpts) => gameAPI.viewInvitation(code, phone, birthDate, nameOpts);
export const requestInvitationViewOTP = (code, phone) => gameAPI.requestInvitationViewOTP(code, phone);
export const verifyInvitationViewOTP = (code, phone, otp) => gameAPI.verifyInvitationViewOTP(code, phone, otp);
export const peekInvitation = (code) => gameAPI.peekInvitation(code);
export const trackInvitationView = (code) => gameAPI.trackInvitationView(code);
